import { Component } from '@angular/core';
import { GaMessageService } from '../../../shared/message/ga-message.service';

@Component({
  selector: 'status-message-demo',
  template: `
    <h2>Status Message</h2>
    <button (click)="showMessage('info')" id="info-trigger">Show info type</button>
    <button (click)="showMessage('success')" id="success-trigger">Show success type</button>
    <button (click)="showMessage('error')" id="danger-trigger">Show danger type</button>
    <button (click)="showMessage('warning')" id="warning-trigger">Show warning type</button>
  `
})
export class StatusMessageDemoComponent {

  constructor(
    private messageService:GaMessageService
  ) {
    /**/
  }

  public showMessage(type:any):void {
    this.messageService.showStatusMessage(`Test status message of ${type}`, undefined, type);
  }
}